import axiosClient from "../../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../../shared/constants/constants";

export const getNewsDetails = (id) => {
  const url = API_URLS.trainingVideoDetailPageApi(id);
  return axiosClient.get(url);
};
